<div *ngIf="allowedAccess" class="content">
  <router-outlet></router-outlet>
</div>
<div *ngIf="!allowedAccess" class="content">
  <form class="dev-form" (ngSubmit)="setDevPassword()" [formGroup]="form">
    <h1>Désolé, MagicPallet n'est pas encore terminé !</h1>
    <input class="input" type="password" placeholder="Mot de passe" formControlName="devPassword">
    <app-loading-button label="Valider"></app-loading-button>
  </form>
</div>
